export enum API_KEY_STATUS {
  ENABLE = 'Enable',
  DISABLE = 'Disable',
  EXPIRED = 'Expired',
  /** @deprecated */ INACTIVE = 'Inactive',
}

export const API_KEY_NAME_MAX_LENGTH = 50;

export const API_KEY_ROUTE_PATH = '/api-key';
